import classNames from 'classnames'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react-lite'
import { Box, Error, Label, Warning } from 'shared/ui'
import { makeTextFieldAutoFocus, makeTextFieldHighlightLimit, TextField } from 'shared/ui/TextField'
import { useRcsCreateContext } from 'pages/settings/pages/rcs/context/rcsCreateContext'

import styles from './styles.module.scss'

export const BrandInfoSection: React.FC = observer(() => {
  const {
    profileStore: {
      brandName,
      setBrandName,
      brandNameError,
      brandDescription,
      setBrandDescription,
      brandDescriptionError,
      brandNameMaxLength,
      isBrandNameMaxLengthReached,
      brandDescriptionMaxLength,
      isBrandDescriptionMaxLengthReached,
    },
  } = useRcsCreateContext()

  return (
    <Fragment>
      <Box display={'grid'} gap={'4px'} mb={'20px'} mt={'30px'}>
        <Label
          label={{
            text: 'Brand name',
            textColor: 'var(--content-primary-primary)',
            horizontal: true,
          }}
        />
        <TextField
          size='medium'
          variant='stroke'
          error={brandNameError}
          InputProps={{
            placeholder: 'Enter name',
            maxLength: brandNameMaxLength,
          }}
          className={classNames({
            [styles.fieldError]: !!brandNameError,
          })}
          value={brandName}
          mainActions={[
            makeTextFieldAutoFocus({ withFocus: true }),
            makeTextFieldHighlightLimit({ limit: brandNameMaxLength }),
          ]}
          onChange={setBrandName}
        />
        <Error type='text' error={brandNameError} />
        <Warning
          text={isBrandNameMaxLengthReached ? `${brandNameMaxLength}-character limit reached` : ''}
        />
      </Box>
      <Box display={'grid'} gap={'4px'} mb={'40px'}>
        <Label
          label={{
            textColor: 'var(--content-primary-primary)',
            text: 'Brand description',
            horizontal: true,
          }}
        />
        <TextField
          size='medium'
          variant='stroke'
          error={brandDescriptionError}
          InputProps={{
            placeholder: 'Enter description',
            maxLength: brandDescriptionMaxLength,
          }}
          className={classNames({
            [styles.fieldError]: !!brandDescriptionError,
          })}
          mainActions={[makeTextFieldHighlightLimit({ limit: brandDescriptionMaxLength })]}
          value={brandDescription}
          onChange={setBrandDescription}
        />
        <Error type='text' error={brandDescriptionError} />
        <Warning
          text={
            isBrandDescriptionMaxLengthReached
              ? `${brandDescriptionMaxLength}-character limit reached`
              : ''
          }
        />
      </Box>
    </Fragment>
  )
})
